"use strict";

import React from "react";
import PropTypes from "prop-types";
import {elementType} from 'prop-types-extra';
import classNames from "classnames";

class Row extends React.Component {
    static propTypes = {
        /**
         * @default 'row'
         */
        bsPrefix: PropTypes.string,

        /** Removes the gutter spacing between `Col`s as well as any added negative margins. */
        noGutters: PropTypes.bool,
        as: elementType,
    };

    static defaultProps = {
        bsPrefix: 'row',
        as: 'div',
        noGutters: false,
    };

    render() {
        const {
            bsPrefix,
            noGutters,
            as: Component,
            className,
            ...props
        } = this.props;

        return (
            <Component
                {...props}
                className={classNames(className, bsPrefix, noGutters && 'no-gutters')}
            />
        );
    }
}

export default Row;